<div class="application-view-main-container">
  <div class="application-view-title">Twój koszyk</div>
  <div class="points-amount-label points-amount-label-error" *ngIf="!this.promoCampaignService.campaignActive;">Zakładka będzie aktywna po zakończeniu promocji.</div>
  <div class="points-amount-label points-amount-label-error" *ngIf="didUserPlaceOrder; else noOrderPlacedYet">Na Twoim koncie dokonano już zamówienia w tej kampanii promocyjnej.</div>
  <ng-template #noOrderPlacedYet>
    <div class="points-amount-label points-amount-label-custom">
      <span>Przydzielona liczba zł: {{ userAssignedPoints }}.</span>
      <span>Pozostałe zł do wykorzystania: {{ userAvailablePoints }}.</span>
    </div>
  </ng-template>
  <div *ngIf="cartItemsSource.length > 0; else emptyCart"
    class="cart-items-container">
    <cart-item-presenter *ngFor="let item of cartItemsSource"
      [cartItemData]="item"></cart-item-presenter>
  </div>
  <ng-template #emptyCart>
    <div class="cart-empty-label">Twój koszyk jest pusty</div>
  </ng-template>

  <!-- Wybór Paczkomatu InPost (Geowidget v5) — nad przyciskiem "Złóż zamówienie".
       Pokazywany tylko gdy jest co zamawiać i zamówienie nie zostało jeszcze złożone. -->
  <div class="parcel-locker-section" *ngIf="!didUserPlaceOrder && cartItemsSource.length > 0">
    <div class="parcel-locker-title">Wybierz Paczkomat InPost do odbioru zamówienia</div>

    <!-- Kontener na Geowidget v5. Sam custom element budujemy imperatywnie w
         komponencie (patrz buildGeowidget), bo token MUSI być na elemencie ZANIM
         trafi on do DOM — inaczej connectedCallback czyta `null` ("Bearer null"). -->
    <div #geowidgetContainer class="parcel-locker-map"></div>

    <div class="parcel-locker-validation-error" *ngIf="showParcelLockerValidationError">
      Wybierz Paczkomat na mapie, aby móc złożyć zamówienie.
    </div>

    <div class="parcel-locker-summary" *ngIf="isParcelLockerSelected">
      <div class="parcel-locker-summary-title">Wybrany Paczkomat:</div>
      <span>Kod punktu: {{ selectedParcelLocker?.name }}</span>
      <span *ngIf="selectedParcelLocker?.address">Adres: {{ selectedParcelLocker?.address }}</span>
      <span *ngIf="selectedParcelLocker?.city">Miasto: {{ selectedParcelLocker?.city }}</span>
      <span *ngIf="selectedParcelLocker?.postCode">Kod pocztowy: {{ selectedParcelLocker?.postCode }}</span>
    </div>
  </div>

  <div class="action-buttons-container">
    <button type="button" class="btn btn-sm btn-secondary btn-secondary-custom"
      (click)="goToBenefitsCatalog()">Katalog nagród</button>
    <button type="button" class="btn btn-sm btn-primary btn-primary-custom"
      [disabled]="!isPlaceOrderButtonEnabled" (click)="placeOrder()">Złóż zamówienie</button>
  </div>
</div>
<waiting-spinner *ngIf="isSpinnerVisible" [text]="'Składanie zamówienia...'"></waiting-spinner>
<alert></alert>